import { put, takeEvery } from 'redux-saga/effects';

import { logger } from '@/config/logger';
import { get as helloServer } from '@/modules/api/codegen';

import { fetchBackendVersion, setBackendVersion } from './slices';

export function* handler() {
    try {
        const { data } = yield helloServer();

        yield put(setBackendVersion(data.serverVersion));
    } catch (error) {
        logger.error(error);
    }
}

export function* saga() {
    yield takeEvery(fetchBackendVersion.toString(), handler);
}
